var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-label",class:_vm.statusClass},[_vm._v("\n\t\t"+_vm._s(_vm.statusText)+"\n\t")])}
var staticRenderFns = []

export { render, staticRenderFns }